export const CREDIT_RATING_OUTLOOKS = [
  {
    key: 'agency',
    displayValue: 'Agency',
  },
  {
    key: 'outlook',
    displayValue: 'Outlook',
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
];
